/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSAxOUg4VjVINVYxOVpNOS41IDE5SDE5VjVIOS41VjE5Wk0zLjUgMjAuNVYzLjVIMjAuNVYyMC41SDMuNVoiIGZpbGw9IiM3RjdGN0YiLz48L3N2Zz4=";